import React from 'react'
import { useTranslation } from 'react-i18next'

import { FieldProps } from '../../../../../../@types/types'
import { ConstructionScreenValidationResult } from '../../../../../../@types/validation-types'
import TextInput from '../../../../../common/inputs/textInput/TextInput'
import { getDefaultClasses } from '../../../../../../utils/style-utils'
import LabelWithTooltip from '../../basicInfo/fields/common/LabelWithTooltip'
import PopoverContent from '../../objectDetails/fields/common/PopoverContent'

type AdditionalLastModernizationFieldProps = {
  showLabelWithTooltip?: boolean
}

export type LastModernizationFieldProps = FieldProps<ConstructionScreenValidationResult> &
  AdditionalLastModernizationFieldProps

const LastModernizationField: React.FC<LastModernizationFieldProps> = ({
  screenName,
  insertionData,
  validationMessages,
  onChange,
  wrapperClassName = getDefaultClasses('right'),
  showLabelWithTooltip = false,
}) => {
  const { t } = useTranslation()
  return (
    <div className={wrapperClassName}>
      {showLabelWithTooltip && (
        <LabelWithTooltip
          inputId='construction-last-modernization'
          labelText={t('wizard.screen.construction.constructionLastModernization')}
          tooltipContent={
            <PopoverContent translationKey='wizard.screen.construction.constructionLastModernization.tooltip' />
          }
          showMandatory={false}
        />
      )}
      <TextInput
        id='construction-last-modernization'
        propertyName='constructionLastModernization'
        type='tel' // 'number' type does not trigger the onChange in safari - using 'tel' is the usual workaround!
        maxLength={4}
        label={
          showLabelWithTooltip
            ? ''
            : t('wizard.screen.construction.constructionLastModernization', 'Last modernization')
        }
        placeholder={t('wizard.screen.construction.constructionYearPlaceholder', 'eg. 1998')}
        value={insertionData.constructionLastModernization?.toString()}
        errors={validationMessages!.constructionLastModernization ?? []}
        doOnFieldChange={(field, value) => {
          onChange({ screen: screenName, property: field }, value)
        }}
      />
    </div>
  )
}

export default LastModernizationField
